import talentPools from "./talent-pools";

export const TALENT_POOLS_NAMESPACE = "talentPools";

export default talentPools;
